import { WatchQueryFetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { useLazyQuery } from 'react-apollo';

export const useMatterDocumentUrlQuery = (fetchPolicy?: WatchQueryFetchPolicy) => {
    const [getData, documentQuery] = useLazyQuery<MatterDocumentUrlData, MatterDocumentUrlParams>(DocumentUrlQuery, {
        fetchPolicy: fetchPolicy
    });

    return {...documentQuery, getData};
};

export interface MatterDocumentUrlParams {
    matterId: number; 
    documentId: number; 
    convertMail: boolean;
    isUserDocument: boolean;
}

export interface MatterDocumentUrlData {
    matter: Matter;
}

export interface Matter {
    documentUrl: string;
}

export const DocumentUrlQuery = gql`
    query DocumentUrlData($matterId: Int!, $documentId: Int!, $convertMail: Boolean, $isUserDocument: Boolean) {
        matter(id: $matterId) {
          documentUrl(documentId: $documentId, convertMail: $convertMail, isUserDocument: $isUserDocument) 
        }
    }
`;